import type { analytique as Fr } from '../fr/analytique';

/** « analytique » in English — typed on the French: a missing sentence does not compile. */
export const analytique: typeof Fr = {
  verdicts: { a_garder: 'Keep', a_surveiller: 'Watch', a_vendre: 'Sell' },
  localeMois: 'en-GB',
  titre: 'Analytics',
  sousTitre: 'Current month · managers only',
  nbMois: (n) => `${n} months`,
  kpi: {
    utilisation: 'Utilisation rate', utilisationDetail: 'industry target 75–85%',
    revenu: 'Revenue per vehicle / day', revenuDetail: 'RevPAC',
    prixMoyen: 'Average daily rate', prixMoyenDetail: 'actually charged',
    duree: 'Average length', dureeValeur: (j) => `${j} d`, dureeDetail: (n) => `${n} ${n === 1 ? 'rental' : 'rentals'}`,
  },
  diagnostic: 'Diagnosis',
  refus: {
    titre: 'The money you don\'t see',
    detail: (n) => `${n} ${n === 1 ? 'request' : 'requests'} turned down for lack of an available vehicle over the period`,
    categorie: 'Most requested category', refus: 'Turned down', manque: 'Lost revenue',
    note: 'Every availability search that found nothing is recorded and valued at the fleet\'s average rate. This is what will tell you when to buy the next vehicle.',
  },
  parMois: {
    titre: 'By vehicle and by month',
    vehicule: 'Vehicle', total: 'Total', marge: 'Margin',
    infobulle: (j, m) => `${j} ${j === 1 ? 'day' : 'days'} rented · ${m}`,
    colonnes: {
      mois: 'Month', locations: 'Rentals', joursLoues: 'Days rented', caLocation: 'Rental revenue',
      supplements: 'Extra charges', prixMoyen: 'Average rate / day', entretien: 'Maintenance',
      joursGarage: 'Days in the garage', marge: 'Margin',
    },
    noteAvant: 'Each cell is the month\'s occupancy rate. ',
    noteGras: 'Click a row',
    noteApres: ' for the details: rentals, days rented, average rate actually charged, maintenance and days in the garage. A rental spanning two months is split pro rata by days.',
  },
  rentabilite: {
    titre: 'Profitability, vehicle by vehicle',
    colonnes: {
      vehicule: 'Vehicle', immatriculation: 'Registration', joursLoues: 'Days rented', utilisation: 'Utilisation',
      ca: 'Revenue', entretien: 'Maintenance', marge: 'Net margin', verdict: 'Verdict',
    },
  },
  equipe: {
    titre: 'Team activity',
    colonnes: {
      personne: 'Person', reservations: 'Bookings', contrats: 'Agreements', encaisse: 'Collected',
      edl: 'Inspections', dommages: 'Unrecorded damage', corrections: 'Correction requests',
    },
    dommagesInfobulle: 'Damage found at check-in but missing from the check-out inspection — each one is a straight loss',
    note: 'These indicators measure work produced. The software records neither location, nor time present, nor any activity outside the application.',
  },
};
